module.exports = __webpack_public_path__ + "media/images/sp/maedori_photowedding/reservation-0a8dfec6dd08997d08c9041371abdee6.webp";